import { Directive, ElementRef, Input, OnChanges, OnInit, Renderer2 } from '@angular/core';

@Directive({
  selector: '[cxPendingLoader]',
  standalone: true,
})
export class CxInputPendingLoaderDirective implements OnInit, OnChanges {
  @Input() cxPendingLoader: boolean | '' | null = null;

  private wrapperElement?: HTMLElement;
  private loaderElement?: HTMLElement;

  constructor(
    private readonly elementRef: ElementRef<HTMLInputElement | HTMLTextAreaElement>,
    private readonly renderer: Renderer2,
  ) {}

  ngOnInit(): void {
    this.ensureLoaderElement();
    this.updateVisibility();
  }

  ngOnChanges(): void {
    this.updateVisibility();
  }

  private ensureLoaderElement(): void {
    if (this.loaderElement) {
      return;
    }

    const input = this.elementRef.nativeElement;
    const parent = input.parentElement;
    if (!parent) {
      return;
    }

    const wrapper = this.renderer.createElement('div');
    this.renderer.addClass(wrapper, 'cx-input-pending-loader-wrapper');
    this.renderer.setStyle(wrapper, 'position', 'relative');
    this.renderer.setStyle(wrapper, 'display', 'block');
    this.renderer.setStyle(wrapper, 'width', '100%');

    this.renderer.insertBefore(parent, wrapper, input);
    this.renderer.appendChild(wrapper, input);
    this.wrapperElement = wrapper;

    if (!input.style.paddingRight) {
      this.renderer.setStyle(input, 'padding-right', '2.5rem');
    }

    const loader = this.renderer.createElement('span');
    const spinner = this.renderer.createElement('span');

    this.renderer.addClass(loader, 'cx-input-pending-loader');
    this.renderer.setStyle(loader, 'position', 'absolute');
    this.renderer.setStyle(loader, 'top', '50%');
    this.renderer.setStyle(loader, 'right', '0.75rem');
    this.renderer.setStyle(loader, 'transform', 'translateY(-50%)');
    this.renderer.setStyle(loader, 'color', 'var(--acx-text-secondary)');
    this.renderer.setStyle(loader, 'display', 'none');
    this.renderer.setStyle(loader, 'align-items', 'center');
    this.renderer.setStyle(loader, 'pointer-events', 'none');

    this.renderer.addClass(spinner, 'spinner-border');
    this.renderer.addClass(spinner, 'spinner-border-sm');
    this.renderer.setAttribute(spinner, 'aria-hidden', 'true');

    this.renderer.appendChild(loader, spinner);
    this.renderer.appendChild(wrapper, loader);

    this.loaderElement = loader;
  }

  private updateVisibility(): void {
    if (!this.loaderElement) {
      return;
    }

    const shouldShow = this.toBoolean(this.cxPendingLoader);

    this.renderer.setStyle(this.loaderElement, 'display', shouldShow ? 'inline-flex' : 'none');
  }

  private toBoolean(value: boolean | '' | null): boolean {
    return value === '' || value === true;
  }
}
